/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@mui/styles';
import { withStyles } from '@mui/styles';
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import colors from '../../../constants/colors';
import CircularIntegration from './CircularIntegration';

const HtmlTooltip = withStyles(() => ({
  tooltip: {
    backgroundColor: '#F9F9F9',
    color: '#000000',
    fontSize: '1.2rem',
  },
}))(Tooltip);

const $MESSAGE = 'Please select some criteria';

const CustomButtons = ({ handleClick, name, disabled, type, tooltipFree, tooltipMessage, loadingButton, loading }) => {
  const defaultColor = disabled ? colors.disabled : colors.black;
  const useStyles = makeStyles(() => ({
    button: {
      marginTop: '0.5rem',
      fontFamily: 'Segoe UI',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '14px',
      width: type === 'special' ? '65px' : '125px',
      color: type === 'special' ? '#F1F0EF !important' : defaultColor,
      backgroundColor: type === 'special' ? colors.grey : 'none',
      '&:hover': {
        backgroundColor: type === 'special' ? '#F1F0EF !important' : colors.grey,
      },
      letterSpacing: '0',
      textTransform: 'none !important',
    },
    tooltip: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }
  }));
  const classes = useStyles('');

  const [criteriaMessage, setCriteriaMessage] = useState($MESSAGE);
  const [openTool, setOpenTool] = useState(false);

  const handleSaveTooltipOpen = () => {
    setOpenTool(disabled);
  };

  const handleSaveTooltipClose = () => {
    setOpenTool(false);
  };

  useEffect(() => {
    if (tooltipMessage) setCriteriaMessage(tooltipMessage);
  }, [tooltipMessage]);

  return (
    <>
      {tooltipFree ? (<HtmlTooltip
        title={(
          <div className={classes.tooltip}>
            <InfoIcon fontSize="small" style={{ padding: '5px' }} />
            <p>{criteriaMessage}</p>
          </div>
        )}
        placement="top"
        enterDelay={400}
        leaveDelay={200}
        open={openTool}
        onOpen={handleSaveTooltipOpen}
        onClose={handleSaveTooltipClose}
      >
        <span>
          <CircularIntegration
            handleButtonClick={handleClick}
            name={name}
            disabled={disabled}
            type={type}
            loadingButton={loadingButton}
            skeleton={loading}
          />
        </span>
      </HtmlTooltip>)
        : (<span>
          <CircularIntegration
            handleButtonClick={handleClick}
            name={name}
            disabled={disabled}
            type={type}
            loadingButton={loadingButton}
            skeleton={loading}
          />
        </span>)
      }
    </>
  )
}

CustomButtons.propTypes = {
  handleClick: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  tooltipFree: PropTypes.bool,
  tooltipMessage: PropTypes.string,
  loadingButton: PropTypes.bool,
  loading: PropTypes.bool
};

CustomButtons.defaultProps = {
  disabled: false,
  type: null,
  tooltipFree: false,
  tooltipMessage: null,
  loadingButton: false,
  loading: false
};

export default CustomButtons;
